// Shim that emulates the @base44/sdk surface used by the app,
// routing all calls to our FastAPI backend.
import { http, handle } from "./http";
import { setNativeToken, clearNativeToken } from "@/lib/native";

const startSession = async (data) => {
  await setNativeToken(data.token);
  return data.user;
};

const auth = {
  me: () => handle(http.get("/auth/me")),
  loginViaEmailPassword: async (email, password) => {
    const data = await handle(http.post("/auth/login", { email, password }));
    return startSession(data);
  },
  register: async ({ email, password, accessCode, fullName }) => {
    const data = await handle(http.post("/auth/register", {
      email, password, access_code: accessCode, full_name: fullName,
    }));
    return startSession(data);
  },
  validateCode: (accessCode) => handle(http.post("/auth/validate-code", { access_code: accessCode })),
  logout: async (redirectTo) => {
    await handle(http.post("/auth/logout"));
    await clearNativeToken();
    if (typeof redirectTo === "string") {
      window.location.href = redirectTo.startsWith("/") ? redirectTo : "/login";
    }
  },
  redirectToLogin: () => { window.location.href = "/login"; },
  resetPasswordRequest: (email, language) => handle(http.post("/auth/forgot-password", { email, language: language || (typeof localStorage !== 'undefined' && localStorage.getItem('mounjaro_language')) || 'pt' })),
  resetPassword: ({ resetToken, newPassword }) =>
    handle(http.post("/auth/reset-password", { token: resetToken, new_password: newPassword })),
  acceptPhotoConsent: () => handle(http.post("/me/consent", { accepted: true })),
  deleteAccount: (password) => handle(http.delete("/me", { data: { password } })),
};

const makeEntity = (resource) => ({
  list: async (_sort, _limit) => handle(http.get(`/${resource}`)),
  filter: async (_filters, _sort, _limit) => handle(http.get(`/${resource}`)),
  create: (body) => handle(http.post(`/${resource}`, body)),
  delete: (id) => handle(http.delete(`/${resource}/${id}`)),
  update: (id, body) => handle(http.put(`/${resource}/${id}`, body)),
});

const entities = {
  WeightRecord: makeEntity("weight-records"),
  ImcRecord: makeEntity("imc-records"),
  Evaluation: makeEntity("evaluations"),
};

const integrations = {
  Core: {
    UploadFile: async ({ file }) => {
      const fd = new FormData();
      fd.append("file", file);
      const data = await handle(http.post("/upload", fd));
      return data; // { file_url, filename }
    },
  },
};

const functions = {
  invoke: async (name, payload) => {
    const map = {
      analyzePhotos: "/analyze-photos",
      evolutiveAnalysis: "/evolutive-analysis",
    };
    const path = map[name];
    if (!path) throw new Error(`Function not implemented: ${name}`);
    const data = await handle(http.post(path, payload));
    return { data };
  },
};

export const base44 = { auth, entities, integrations, functions };
